import React, { useEffect, useState } from "react";
import Sidebar from "../StudentSidebar/Sidebar";
import StudentNavbar from "../StudentNavbar/StudentNavbar";
import { PngImages, SvgImages } from "../../Utils/LocalImages";
import Image from "../../Components/Reusable/Image";


const PaidSyllabus = () => {

    return (
        <div className="d-flex">
            <Sidebar />
            <div className="mainLayout-content">
                <StudentNavbar />
                <div className="main_content contentSection scroll_bar">
                    <div className="mb-4 d-flex justify-content-between align-items-center">
                        <h1 className="black sub-large-text-one fw-600 mb-0">GREAT! Now you can access the Pradnya Learnitics/special syllabus.</h1>
                    </div>
                    <div className="row">
                        <div className="col-md-6 col-sm-6 col-lg-4 col-xl-3">

                            <div
                                className="accordianPaid py-3 ps-3 pe-3 borderten"
                            >  <div className="d-flex gap-2 align-items-center ">
                                    <Image src={SvgImages.crownimg} />
                                    <div className="d-flex justify-content-between w-100 align-items-center">
                                        <h1 className="white small-medium-text fw-600 mb-0">
                                            Start Your Syllabus
                                        </h1>
                                        <Image src={PngImages.paidsyllabuspng} className="cursor-pointer" />
                                    </div>

                                </div>
                            </div>

                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
};

export default PaidSyllabus;
